import App from './app';


window.addEventListener('load', () => {
    const appElemSelector = document.querySelector('#app');
    const app = new App(appElemSelector);
})